// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const VersionsIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.17 19H9a3 3 0 0 1-2.83-2H5a3 3 0 0 1-3-3v-4a3 3 0 0 1 3-3h1.17A3 3 0 0 1 9 5h1.17A3 3 0 0 1 13 3h6a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3h-6a3 3 0 0 1-2.83-2M10 7H9a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h1zm2-1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1zM6 9v6H5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1z"
      clipRule="evenodd"
    />
  </svg>,
  "Versions",
);
export default VersionsIcon;
